/**
     * PhotoUploaded.contract.ts — Event Contract System™ (generation v1).
     * Reserved: declared for future media flows; no production publisher or subscriber yet.
     */

    import type { EventContract } from '../EventContractRegistry';

    export const PhotoUploadedContract: EventContract = {
      name: 'PhotoUploaded',
      version: 1,
      description: "Reserved: declared for future media flows; no production publisher or subscriber yet.",
      publishers: [],
      subscribers: [],
      fields: [
        { name: 'photoId', type: 'string', required: true, description: "Identifier of the uploaded photo" },
      ],
      allowExtraFields: true,
      timestampPolicy: "Publish time (Date.now()) at upload completion.",
      stability: 'reserved',
      deprecated: false,
      example: null,
    };
    